import React, { useMemo } from 'react'
import Modal from '../../../../../../../../shared/components/Modal'
import { Container, ContainerContent, Subtitle, Title } from './styles'
import iconeFalha from 'shared/assets/icons/icon-falha.svg'
import iconeSucesso from 'shared/assets/icons/icon-concluido-green.svg'
import Button from '../../../../../../../../shared/components/Button'
import EExportarExtratoTipoMensagem from '../../../../../../domain/entities/EExportarExtratoTipoMensagem'
import { format, subDays } from 'date-fns'

export interface IModalSolicitacaoExtratoProps {
  sucesso: boolean
  isOpened: boolean
  closeModal: () => void
  tipo: EExportarExtratoTipoMensagem
}
const ModalSolicitacaoExtrato: React.FC<IModalSolicitacaoExtratoProps> = ({
  sucesso,
  isOpened,
  closeModal,
  tipo,
}) => {
  const subtituloModal = useMemo(() => {
    switch (tipo) {
      case EExportarExtratoTipoMensagem.SUCESSO:
        return 'Estamos processando seu extrato. O arquivo será enviado ao seu e-mail dentro de algumas horas.'
      case EExportarExtratoTipoMensagem.ERRO:
        return 'Não foi possível gerar o extrato, tente realizar uma nova solicitação dentro de alguns minutos.'
      case EExportarExtratoTipoMensagem.VALIDACAO_PERIODO:
        return `Período máximo para esta solicitação é de 31 dias.`
      default:
        return ''
    }
  }, [tipo])

  return (
    <>
      <Modal
        openModal={isOpened}
        curvature={true}
        showCloseButton={true}
        onCloseModal={closeModal}
      >
        <Container>
          <ContainerContent>
            <p>
              <img src={sucesso ? iconeSucesso : iconeFalha} />
            </p>
            <p
              style={{
                marginTop: 16,
                marginBottom: 16,
                width: 460,
                textAlign: 'center',
              }}
            >
              <Title>
                {sucesso
                  ? 'Solicitação do extrato realizada'
                  : 'Falha na solicitação do extrato'}
              </Title>
            </p>
            <p
              style={{
                width: 460,
                textAlign: 'center',
              }}
            >
              <Subtitle>{subtituloModal}</Subtitle>
            </p>

            <p
              style={{
                marginTop: 46,
              }}
            >
              <Button
                style={{
                  backgroundColor: '#24A95D',
                  width: '100%',
                  fontWeight: 600,
                  fontSize: 14,
                }}
                onClick={closeModal}
              >
                Fechar
              </Button>
            </p>
          </ContainerContent>
        </Container>
      </Modal>
    </>
  )
}

export default ModalSolicitacaoExtrato
